import { useQuery } from 'data-fetching-client';
import { useSelector } from 'react-redux';
import I18n from 'I18n';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { GET_PREFERRED_CURRENCY } from '../../../api/dataFetchingQueries';
import { getCompanyCurrency } from '../../../selectors/multiCurrencySelectors';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
const useFetchPreferredCurrency = () => {
  const companyCurrency = useSelector(getCompanyCurrency);
  const {
    data,
    loading,
    error
  } = useQuery(GET_PREFERRED_CURRENCY);
  if (error && error.networkError &&
  //@ts-expect-error ApolloError object typing issue
  error.networkError.status !== 404) {
    FloatingAlertStore.addAlert({
      message: I18n.text('multicurrencyPanel.fetch.error.message'),
      titleText: I18n.text('multicurrencyPanel.fetch.error.title'),
      type: 'danger'
    });
    logRavenException(error, 'Fetch Preferred Currency');
  }
  const preferredCurrency = data && data.preferredCurrency ? data.preferredCurrency.preferredCurrency : null;
  const userHasDifferentPreferredCurrency = preferredCurrency !== null && preferredCurrency !== companyCurrency;
  return {
    data: preferredCurrency,
    userHasDifferentPreferredCurrency,
    loading,
    error
  };
};
export default useFetchPreferredCurrency;